import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { withRouter } from 'react-router';
import BullishAccount from './bullish-account/bullish-account';
import RFQ from './rfq/rfq';
import bullishContext from '../../stores/bullish-store';
import { useTabQueryString } from '../../hooks/use-tab-query-string';

const useStyles = makeStyles({
  tabs: {
    paddingBottom: 20,
  },
  tab: {
    width: 220,
  },
});

const BullishGroup = ({ location, history }) => {
  const classes = useStyles();
  const bullish = React.useContext(bullishContext);
  const { tab, setTab } = useTabQueryString('options');

  React.useEffect(() => {
    bullish.fetch();
  }, [bullish]);

  return (
    <div data-testid="bullish">
      <Tabs
        value={tab}
        onChange={(_, selectedTab) => setTab(selectedTab)}
        className={classes.tabs}
      >
        <Tab value="options" className={classes.tab} label="RFQ" />
        <Tab value="account" className={classes.tab} label="Account" />
      </Tabs>
      {tab === 'options' && <RFQ source={bullish} />}
      {tab === 'account' && <BullishAccount source={bullish} />}
    </div>
  );
};

export default withRouter(BullishGroup);
